// extracted by mini-css-extract-plugin
module.exports = {"dropzone-container":"dropzone_dropzone-container__8Xa93","dropzone-overlay":"dropzone_dropzone-overlay__3i3AO"};